import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Box, Flex, Text } from "pcln-design-system";
import { Pin } from "pcln-icons";
import { truncateString } from "../../../../utils/truncateText.js";
const Header = ({ hotelName, neighborhoodName })=>/*#__PURE__*/ jsxs(Box, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                fontWeight: 'bold',
                fontSize: 1,
                lineHeight: '19px',
                children: truncateString(hotelName, 65)
            }),
            /*#__PURE__*/ jsxs(Flex, {
                py: 1,
                alignItems: 'center',
                children: [
                    /*#__PURE__*/ jsx(Pin, {
                        color: "primary.base",
                        size: 16
                    }),
                    /*#__PURE__*/ jsx(Text, {
                        fontSize: 0,
                        lineHeight: '16px',
                        color: 'primary.base',
                        ml: 1,
                        children: truncateString(neighborhoodName, 30)
                    })
                ]
            })
        ]
    });
const Header_Header = Header;
export { Header_Header as default };
